export default "__VITE_ASSET__Dui8VpyI__"